<template>
    <div>
        <section id="promo-header">
            <div class="container text-center py-3">
                <h2 class="font-size-large mb-3"><i>Scriv sorteia:</i></h2>
                <h2 class="font-size-xLarge mb-3"><span class="highlighted highlight-left">Coleções de Livros</span></h2>
            </div>
        </section>
        <section class="my-5">
            <div class="container text-md-left text-center">
                <div class="mx-auto my-4 col-md-10 d-flex flex-column flex-md-row justify-content-center justify-content-md-between">
                    <div class="px-0 col-md-3 m-3">
                        <img src="/images/landing-pages/promo/clarice.png" alt="Coleção Clarice Lispector"/>
                    </div>
                    <div class="px-2 col-md-9 m-3 pt-4">
                        <div class="col-md-12 px-0">
                            <h3 class="font-size-large"><span class="highlighted highlight-left">Clarice Lispector</span></h3>
                            <p class="font-size-medium mb-2">Coleção especial com 18 livros + brinde exclusivo.</p>
                        </div>
                        <div class="container d-md-flex px-0">
                            <div class="col-md-6 px-0">
                                <p class="font-size-small">
                                    <i>Concorrem os autores que publicarem um </i><strong>livro pago </strong><i>entre os dias 21/02 e 15/03/2022.</i>
                                </p>
                            </div>
                            <div class="col-md-5 mx-md-4">
                                <router-link
                                    :to="{ name: 'books.create' }"
                                    target="_blank"
                                    class="btn btn-primary mt-2"
                                    v-if="authenticated"
                                >
                                Escrever
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mx-auto my-4 col-md-10 d-flex flex-column flex-md-row justify-content-center justify-content-md-between">
                    <div class="px-0 col-md-3 m-3">
                        <img src="/images/landing-pages/promo/machado.png" alt="Coleção Machado de Assis"/>
                    </div>
                    <div class="px-2 col-md-9 m-3 pt-4">
                        <div class="col-md-12 px-0">
                            <h3 class="font-size-large"><span class="highlighted highlight-left">Machado de Assis</span></h3>
                            <p class="font-size-medium mb-2">Box com 11 livros em capa dura + biografia do autor.</p>
                        </div>
                        <div class="container d-md-flex px-0">
                            <div class="col-md-6 px-0">
                                <p class="font-size-small">
                                    <i>Concorrem os autores que publicarem um </i><strong>texto individual </strong><i>entre os dias 21/02 e 15/03/2022.</i>
                                </p>
                            </div>
                            <div class="col-md-5 mx-md-4">
                                <router-link
                                    :to="{ name: 'posts.create' }"
                                    target="_blank"
                                    class="btn btn-primary mt-2"
                                    v-if="authenticated"
                                >
                                Escrever
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mx-auto my-4 col-md-10 d-flex flex-column flex-md-row justify-content-center justify-content-md-between">
                    <div class="px-0 col-md-3 m-3">
                        <img src="/images/landing-pages/promo/duna.png" alt="Trilogia Duna"/>
                    </div>
                    <div class="px-2 col-md-9 m-3 pt-4">
                        <div class="col-md-12 px-0">
                            <h3 class="font-size-large"><span class="highlighted highlight-left">Trilogia Duna</span></h3>
                            <p class="font-size-medium mb-2">Box da primeira trilogia da saga + mapa de Arrakis.</p>
                        </div>
                        <div class="container d-md-flex px-0">
                            <div class="col-md-6 px-0">
                                <p class="font-size-small">
                                    <i>Concorrem todos que estiverem seguindo o @scrivapp no </i><strong>Instagram </strong><i>até o dia 15/03/2022.</i>
                                </p>
                            </div>
                            <div class="col-md-5 mx-md-4">
                                <a
                                    href="https://www.instagram.com/scrivapp/"
                                    target="_blank"
                                    class="btn btn-primary mt-2"
                                >
                                Seguir
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mx-auto my-4 col-md-10 d-flex flex-column flex-md-row justify-content-center justify-content-md-between">
                    <div class="px-0 col-md-3 m-3">
                        <img src="/images/landing-pages/promo/tolkien.png" alt="Coleção J. R. R. Tolkien"/>
                    </div>
                    <div class="px-2 col-md-9 m-3 pt-4">
                        <div class="col-md-12 px-0">
                            <h3 class="font-size-large"><span class="highlighted highlight-left">J. R. R. Tolkien</span></h3>
                            <p class="font-size-medium mb-2">Edição de luxo de O Senhor dos Anéis + O Hobbit.</p>
                        </div>
                        <div class="container d-md-flex px-0">
                            <div class="col-md-6 px-0">
                                <p class="font-size-small">
                                    <i>Concorrem todos que estiverem seguindo o @scrivapp no </i><strong>Twitter </strong><i>até o dia 15/03/2022.</i>
                                </p>
                            </div>
                            <div class="col-md-5 mx-md-4">
                                <a
                                    href="https://www.twitter.com/scrivapp/"
                                    target="_blank"
                                    class="btn btn-primary mt-2"
                                >
                                Seguir
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mx-auto my-4 col-md-10 d-flex flex-column flex-md-row justify-content-center justify-content-md-between">
                    <div class="px-0 col-md-3 m-3">
                        <img src="/images/landing-pages/promo/orwell.png" alt="Coleção George Orwell"/>
                    </div>
                    <div class="px-2 col-md-9 m-3 pt-4">
                        <div class="col-md-12 px-0">
                            <h3 class="font-size-large"><span class="highlighted highlight-left">George Orwell</span></h3>
                            <p class="font-size-medium mb-2">Box exclusivo com 6 obras completas do britânico.</p>
                        </div>
                        <div class="container d-md-flex px-0">
                            <div class="col-md-6 px-0">
                                <p class="font-size-small">
                                    <i>Concorrem todos que estiverem seguindo nosso perfil no </i><strong>Linkedin </strong><i>até o dia 15/03/2022.</i>
                                </p>
                            </div>
                            <div class="col-md-5 mx-md-4">
                                <a
                                    href="https://www.linkedin.com/company/scriv/"
                                    target="_blank"
                                    class="btn btn-primary mt-2"
                                >
                                Seguir
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mx-auto my-4 col-md-10 d-flex flex-column flex-md-row justify-content-center justify-content-md-between">
                    <div class="px-0 col-md-3 m-3">
                        <img src="/images/landing-pages/promo/marquez.png" alt="Coleção Gabriel García Márquez"/>
                    </div>
                    <div class="px-2 col-md-9 m-3 pt-4">
                        <div class="col-md-12 px-0">
                            <h3 class="font-size-large"><span class="highlighted highlight-left">Gabriel García Márquez</span></h3>
                            <p class="font-size-medium mb-2">Edição de colecionador com 3 livros do colombiano.</p>
                        </div>
                        <div class="container d-md-flex px-0">
                            <div class="col-md-6 px-0">
                                <p class="font-size-small">
                                    <i>Concorrem todos que estiverem seguindo nosso perfil no </i><strong>Spotify </strong><i>até o dia 15/03/2022.</i>
                                </p>
                            </div>
                            <div class="col-md-5 mx-md-4">
                                <a
                                    href="https://open.spotify.com/show/77kkJ5WrnvC83L74mSSea7"
                                    target="_blank"
                                    class="btn btn-primary mt-2"
                                >
                                Seguir
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <hr class="h-3 background-color2 my-4"/>

        <section class="mt-3 mb-1">
            <div class="container text-center py-3">
                <h2 class="font-size-xLarge mb-3"><span class="highlighted highlight-left">Regras de Participação</span></h2>
            </div>
        </section>

        <section class="my-1">
            <div class="container text-left py-3">
                <div class="mx-auto my-4 col-md-9 d-flex flex-column flex-md-row justify-content-center justify-content-md-between">
                    <p>
                        <strong>1) </strong> Uma mesma pessoa pode participar de todos os sorteios de forma simultânea, mas poderá vencer apenas um deles.
                    </p>
                </div>
                <div class="mx-auto my-4 col-md-9 d-flex flex-column flex-md-row justify-content-center justify-content-md-between">
                    <p>
                        <strong>2) </strong> Os sorteios serão realizados na ordem desta página (sendo Clarice Lispector o primeiro e Gabriel García Márquez o último). O vencedor de cada sorteio não será considerado para os sorteios seguintes.
                    </p>
                </div>
                <div class="mx-auto my-4 col-md-9 d-flex flex-column flex-md-row justify-content-center justify-content-md-between">
                    <p>
                        <strong>3) </strong> Os sorteios serão feitos no dia 16/03/2022 e os vencedores serão divulgados em nossas redes sociais no dia 17/03/2022.
                    </p>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  metaInfo: {
    title: 'Scriv sorteia: Coleções de Livros',
    meta: [
      { vmid: 'description', name: 'description', content: 'Entre na Scriv e concorra a coleções exclusivas de livros de Machado de Assis, Clarice Lispector, George Orwell e muito mais!' },
      { vmid: 'og-description', name: 'og:description', content: 'Entre na Scriv e concorra a coleções exclusivas de livros de Machado de Assis, Clarice Lispector, George Orwell e muito mais!' }
    ]
  },
  computed: {
    ...mapState('auth', {
      authenticated: state => state.authenticated
    })
  }
}

</script>

<style lang="scss" scoped>
hr {
    width: 70%;
}
</style>
